import type { FC } from 'react';
import Box from '@mui/material/Box';
import { Actions as FacebookActions, LastActivities as FacebookLastActivities } from 'features/cabinet/facebook';

const OverviewDashboard: FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 4, pt: 2 }}>
      <FacebookLastActivities />
      <FacebookActions />
    </Box>
  );
};

export default OverviewDashboard;